import ShortLoadingAnimation from './short-loading.js';
import Loading from './loading.js';
import './modernizr-custom.js';
/**
 * 指定時間後にpromiseを返す
 *
 * @param {int} ms
 */
function sleep(ms) {
  return new Promise(function(resolve) {
    setTimeout(function() {
      resolve();
    }, ms);
  });
}
const css = document.createElement('link');
css.rel = "stylesheet";
css.href = templatePath + "/css/home.css?04";

const visitKey = 'lastVisit';
const threeDays = 1000 * 60 * 60 * 24 * 3;

let lastVisit = localStorage.getItem(visitKey);

if (lastVisit !== null) {
  let elapsed = Date.now() - new Date(lastVisit).getTime();
  if (elapsed < threeDays) {
    window.referrer = true;
  }
}

localStorage.setItem(visitKey, new Date().toISOString());

if(isHome && !window.referrer )
{
  window.loading = new Loading(6);
  const loadingDisplay = window.loading.createDisplay();
  window.addEventListener('DOMContentLoaded',()=>{
    window.loading.start(loadingDisplay);
    document.head.appendChild(css);
  });
  window.addEventListener('load', ()=>{
    window.loading.pointLoaded();
  });
  document.fonts.ready.then( () => {
    window.loading.pointLoaded();
  });
}else if(!isHome)
{
  topShortLoad = new ShortLoadingAnimation;
  window.addEventListener('DOMContentLoaded',()=>{
    document.head.appendChild(css);
    document.body.classList.remove('loading');
    topShortLoad.start();
  });
  document.fonts.ready.then(function() {
    topShortLoad.end();
  });
}else
{
  topShortLoad = new ShortLoadingAnimation;
  window.addEventListener('DOMContentLoaded',()=>{
    document.head.appendChild(css);
    document.body.classList.remove('loading');
    topShortLoad.start();
  });

}

window.addEventListener( 'load', e =>{
  document.body.addEventListener('touchstart',()=>{},{passive: true});
  const headerNav = S('.jsHeaderNav');
  const scrollNavClose = () => {
    const target = S(".jsMobileMenu").classList;
    target.toggle("header-mobile-menu--on");
    target.toggle("header-mobile-menu--off");
    headerNav.classList.toggle("header-nav--on");
    headerNav.classList.toggle("header-nav--off");
    window.removeEventListener("scroll",scrollNavClose,{passive:true});
    sleep(600)
      .then(()=>{
        target.remove("header-mobile-menu--off");
        headerNav.classList.remove("header-nav--off");
    });
  }

  S(".jsMobileMenu").addEventListener( "click", e => {
    const target = e.currentTarget.classList;
    if(!target.contains("header-mobile-menu--on") && !target.contains("header-mobile-menu--off"))
    {
      target.add("header-mobile-menu--on");
      headerNav.classList.add("header-nav--on");
    }else
    {
      target.toggle("header-mobile-menu--on");
      target.toggle("header-mobile-menu--off");
      headerNav.classList.toggle("header-nav--on");
      headerNav.classList.toggle("header-nav--off");
    }
    if(target.contains("header-mobile-menu--on"))
    {
      window.addEventListener("scroll",scrollNavClose,{passive:true});
    }else
    {
      window.removeEventListener("scroll",scrollNavClose,{passive:true});
      sleep(600)
        .then(()=>{
          target.remove("header-mobile-menu--off");
          headerNav.classList.remove("header-nav--off");
      });
    }
  });
  const headerObserveOptions = {
    root: null,
    threshold: 0
  };
  const header = S('.header');
  const headerContact = S('.jsHeaderContact');
  const headerTopContact = S('.jsTopContact');
  const headerObserveCallback = e => {
    if( e[0].isIntersecting )
    {
      header.classList.remove('header--fixed');
      headerNav.classList.remove('header-nav--fixed');
      headerContact.classList.remove('header-nav__contact-icon--fixed');
      headerTopContact.classList.remove('header__contact-icon--fixed');
    }else
    {
      header.classList.add('header--fixed');
      headerNav.classList.add('header-nav--fixed');
      headerTopContact.classList.add('header__contact-icon--fixed');
      headerContact.classList.add('header-nav__contact-icon--fixed');
    }
  }
  const headerObserver = new IntersectionObserver(headerObserveCallback, headerObserveOptions);
  headerObserver.observe(header);

});
